/**
 * Faraid API composable
 * Provides methods for all Faraid module API endpoints
 */
import { apiClient } from '@shared/utils/apiClient.js'

export function useFaraid() {
  // ==================== PUBLIC CALCULATOR ====================
  const calculate = (data) => apiClient.post('/v1/faraid/calculate', data)

  // ==================== DASHBOARD ====================
  const getDashboard = () => apiClient.get('/v1/faraid/dashboard')

  // ==================== CASES ====================
  const listCases = (params) => apiClient.get('/v1/faraid/cases', { params })
  const getCase = (id) => apiClient.get(`/v1/faraid/cases/${id}`)
  const createCase = (data) => apiClient.post('/v1/faraid/cases', data)
  const cancelCase = (id) => apiClient.post(`/v1/faraid/cases/${id}/cancel`)
  const disputeCase = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/dispute`, data)
  const respondToInfoRequest = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/respond`, data)
  const deliverCase = (id) => apiClient.post(`/v1/faraid/cases/${id}/deliver`)

  // ==================== CASE SUB-RESOURCES ====================
  const getCaseCalculation = (id) => apiClient.get(`/v1/faraid/cases/${id}/calculation`)
  const getCaseNotes = (id, params) => apiClient.get(`/v1/faraid/cases/${id}/notes`, { params })
  const addCaseNote = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/notes`, data)
  const getCaseHistory = (id) => apiClient.get(`/v1/faraid/cases/${id}/history`)
  const getCaseReviews = (id) => apiClient.get(`/v1/faraid/cases/${id}/reviews`)

  // ==================== SCHOLAR WORKFLOW ====================
  const getScholarQueue = (params) => apiClient.get('/v1/faraid/scholar-queue', { params })
  const pickupCase = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/pickup`, data)
  const approveCase = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/approve`, data)
  const adjustCase = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/adjust`, data)
  const overrideCase = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/override`, data)
  const requestInfo = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/request-info`, data)
  const reEvaluateCase = (id, data) => apiClient.post(`/v1/faraid/cases/${id}/re-evaluate`, data)
  const generateReviewLink = (id) => apiClient.post(`/v1/faraid/cases/${id}/review-link`)

  // ==================== SCHOLARS ====================
  const listScholars = (params) => apiClient.get('/v1/faraid/scholars', { params })
  const getScholar = (id) => apiClient.get(`/v1/faraid/scholars/${id}`)
  const createScholar = (data) => apiClient.post('/v1/faraid/scholars', data)
  const updateScholar = (id, data) => apiClient.put(`/v1/faraid/scholars/${id}`, data)
  const deactivateScholar = (id) => apiClient.delete(`/v1/faraid/scholars/${id}`)

  // ==================== SETTINGS ====================
  const getSettings = () => apiClient.get('/v1/faraid/settings')
  const updateSettings = (data) => apiClient.put('/v1/faraid/settings', data)

  // ==================== REFERENCE DATA ====================
  const getHeirRules = (params) => apiClient.get('/v1/faraid/heir-rules', { params })

  // ==================== MESSAGE LOGS ====================
  const getMessageLogs = (params) => apiClient.get('/v1/faraid/messages', { params })

  return {
    // Public
    calculate,
    // Dashboard
    getDashboard,
    // Cases
    listCases,
    getCase,
    createCase,
    cancelCase,
    disputeCase,
    respondToInfoRequest,
    deliverCase,
    // Case sub-resources
    getCaseCalculation,
    getCaseNotes,
    addCaseNote,
    getCaseHistory,
    getCaseReviews,
    // Scholar workflow
    getScholarQueue,
    pickupCase,
    approveCase,
    adjustCase,
    overrideCase,
    requestInfo,
    reEvaluateCase,
    generateReviewLink,
    // Scholars
    listScholars,
    getScholar,
    createScholar,
    updateScholar,
    deactivateScholar,
    // Settings
    getSettings,
    updateSettings,
    // Reference data
    getHeirRules,
    // Messages
    getMessageLogs,
  }
}
